import React, { useState, useEffect } from "react";
import { GatsbyImage } from "gatsby-plugin-image";

import Button from "../button/button";
import formatDate from "../../utils/format-date";

const Sidebar = ({ post, type, department }) => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const [activeChapter, setActiveChapter] = useState("");
    const [nearTop, setNearTop] = useState(true);
    const [headerDown, setHeaderDown] = useState("");

    let acf = post.case_study_fields;
    let hasACF = (typeof acf !== "undefined" && acf !== null);

    let chapters = [];

    let date;

    if(post.date) {
        date = formatDate(post.date);
    }

    const handleChapterTitles = () => {
        if(isSidebarOpen) {
            setSidebarOpen(false);
        }else{
            setSidebarOpen(true);
        };
    };

    const chapterTitleTransition = () => {
        setTimeout(() => {
            const headroom = document.querySelectorAll(".headroom--pinned");

            if (headroom && headroom.length > 0) {
                setHeaderDown("report-sidebar-header-down animate-chapter-header-up");
            } else {
                setHeaderDown("report-sidebar-header-up animate-chapter-header-down");
            }
        }, 200);
    };

    const reportSidebarContent = (post) => {
        if (post.report_fields) {
            let chapters = post.report_fields.reportContent;

            var sidebarChapters = [];
            chapters.forEach(chapter => {
                
                var chapterWithSections = {
                    "title": chapter.chapterTitle,
                    "sections": []
                };
    
                chapter.chapterContent.forEach(content => {
                    if (content.subChapter) {
                        chapterWithSections.sections.index = content.subChapter;
                    };
                });
                
                sidebarChapters.push(chapterWithSections)
            });
            return sidebarChapters;
        };
        return null;
    };

    const handleNavigate = () => {
        setSidebarOpen(false);
    };
    
    const currentChapter = () => {
        const chapterHeader = document.querySelector(".report-sidebar");
        if(chapterHeader !== null) {
            const observerBody = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setActiveChapter(entry.target.id);
                    }
                });
            });
            
            chapters.forEach((chapter) => {
                if( chapter || chapter !== "" ) {
                    if(document.getElementById(`${chapter}`)) {
                        observerBody.observe(document.getElementById(`${chapter}`));
                    }
                }
            })
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', function() {
            setNearTop(window.pageYOffset / window.innerHeight > 1);
            currentChapter();
            chapterTitleTransition();
        });
    });

    useEffect(() => {
        document.querySelectorAll('.body_text').forEach((chapter) => {
            chapters.push(chapter.id);
        });
    });

    switch(type) {
        case "blog":
            return (
                <div className={`post-sidebar service-background-light-${department}`}>
                    <div className="post-sidebar-container">
                        <div className="post-sidebar-container-content">
                            <img src={ post.author.node.avatar.url } className="lazyload author-image" alt="" />
                            <p className="post-sidebar-container-content-author" dangerouslySetInnerHTML={{ __html: `Written by ${ post.author.node.firstName }<br/>${ date }`}} />
                            <h3 className="post-title" dangerouslySetInnerHTML={{ __html: post.title }} />
                            <Button to={ "#similar_posts_section" } title={ "View similar posts" } type={ department }>
                                More like this
                            </Button>
                        </div>
                    </div>
                </div>
            );
        case "case-study":
            return (
                <div className={`post-sidebar service-background-light-${department}`}>
                    <div className="post-sidebar-container">
                        <div className="post-sidebar-container-content">
                            {(hasACF && acf.uploadClientLogo !== null)
                            ?
                                <div className="client-logo-container">
                                    <a 
                                        href={(hasACF && acf.flauntMetaClientsLink !== null) ? (acf.flauntMetaClientsLink) : null} 
                                        title={(hasACF && acf.flauntMetaClientsName !== null) ? (acf.flauntMetaClientsName) : null} 
                                        target='_blank'
                                        rel="noreferrer"
                                    >
                                        <GatsbyImage image={ acf.uploadClientLogo.localFile.childImageSharp.gatsbyImageData } className="lazyload client-logo" alt="" />
                                    </a>
                                </div>
                            :
                                null
                            }
                            <p className="post-service-title">{ post.servicesTaxonomy.nodes[0].name }</p>
                            <h3 className="post-title" dangerouslySetInnerHTML={{ __html: post.title }} />
                            <Button 
                                to={ "#similar_posts_section" } 
                                title={ "View similar posts" } 
                                type={ department }
                            >
                                More like this
                            </Button>
                        </div>
                    </div>
                </div>
            );
        case "report":
            return (
                <div className={ `post-sidebar ${ headerDown } report-sidebar` }>
                    <div className="post-sidebar-container">
                        <div className={`post-sidebar-container-content report-sidebar-container-content ${ isSidebarOpen?"full-height animate-chapter-sidebar-down":"animate-chapter-sidebar-up" }`}>
                            { activeChapter && nearTop ?
                                <a className={ isSidebarOpen ? 'sidebar-title sidebar-chapter-current' : 'sidebar-chapter-link sidebar-chapter-title-has-sections sidebar-chapter-current' }      
                                    onClick={ handleChapterTitles }>
                                    <span className="sidebar-chapter-title h-large">
                                        { isSidebarOpen ? "chapters" : activeChapter.replace(/[\W_]+/g, " ").toLowerCase() }
                                    </span>
                                </a>
                            :
                                null
                            }
                            { reportSidebarContent(post).map((reportContent) => {
                                return(
                                    <div 
                                        key={ reportContent.title } 
                                        className={ isSidebarOpen && activeChapter.replace(/[\W_]+/g, " ").toLowerCase() === reportContent.title.replace(/[\W_]+/g, " ").toLowerCase() ? "sidebar-chapter active-chapter" : isSidebarOpen ? "sidebar-chapter" : "section-hidden sidebar-chapter" }>
                                        <a 
                                            className="sidebar-chapter-link sidebar-chapter-title-has-sections" 
                                            onClick={ handleNavigate } 
                                            href={ `#${ reportContent.title.replace(/[\W_]+/g, "_").toLowerCase() }` }>
                                            <span 
                                                className="sidebar-chapter-title h-large">
                                                { reportContent.title }
                                            </span>
                                        </a>
                                        { reportContent.sections.map((section) => {
                                            return(
                                                <a 
                                                    key={ section } 
                                                    className={ activeChapter.replace(/[\W_]+/g, " ").toLowerCase() === reportContent.title.replace(/[\W_]+/g, " ").toLowerCase() ? "" : "section-hidden-all" } 
                                                    onClick={ handleNavigate } 
                                                    href={ `#${ section.replace(/[\W_]+/g, "_").toLowerCase() }` }>
                                                    <span className="sidebar-chapter-section">
                                                        { section }
                                                    </span>
                                                </a>
                                            );
                                        })}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            );
        default :
            break;
    }; 
};

export default Sidebar;